import { render } from "./ReviewJob.vue?vue&type=template&id=116fee20&scoped=true"
import script from "./ReviewJob.vue?vue&type=script&lang=js"
export * from "./ReviewJob.vue?vue&type=script&lang=js"

import "./ReviewJob.vue?vue&type=style&index=0&id=116fee20&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3554799265/src/syndesi-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-116fee20"]])

export default __exports__